import React from 'react';
import PropTypes from 'prop-types';
import { Report } from 'cccisd-laravel-report';
import { reportTemplatePlayer } from 'cccisd-laravel-appdefs';
import { initialValues } from '../Builder';
import widgets from '../widgets';
import AnswerSummaryPage from './Page';

const AssessmentReportPlayer = props => {
    const { settings = {}, widgetsAsFunctions, widgetProps } = props;
    const {
        header = initialValues.header,
        footer = initialValues.footer,
        filename = initialValues.filename,
    } = settings;

    const dynamicWidgetListFunction = widgetsAsFunctions?.dynamicWidgetList;

    const pages = { 1: [] };
    let pageCount = 1;
    if (Array.isArray(settings?.widgets?.dynamicWidgetList?.widgetList)) {
        settings.widgets.dynamicWidgetList.widgetList.forEach(block => {
            if (!Array.isArray(pages[pageCount])) {
                pages[pageCount] = [];
            }

            if (block.type === 'pageBreak') {
                pageCount++;
                pages[pageCount] = [];
                return;
            }

            pages[pageCount].push(block);
        });
    }

    return (
        <Report downloadFilename={filename}>
            {Object.keys(pages).map(pageNum => (
                <AnswerSummaryPage header={header} footer={footer} pageNum={pageNum} key={pageNum}>
                    {dynamicWidgetListFunction &&
                        dynamicWidgetListFunction({
                            settings: { widgetList: pages[pageNum], ...widgetProps },
                        })}
                </AnswerSummaryPage>
            ))}
        </Report>
    );
};

AssessmentReportPlayer.propTypes = {
    settings: PropTypes.object,
    isPreview: PropTypes.bool,
    filters: PropTypes.object,
    widgets: PropTypes.object,
    widgetsAsFunctions: PropTypes.object,
    widgetProps: PropTypes.object,
    data: PropTypes.object,
};

export default reportTemplatePlayer({
    getWidgets: props =>
        widgets.map(w => ({
            ...w,
            widgetProps: {
                widgetMargin: props.settings.widgetMargin || initialValues.widgetMargin,
                answerBackgroundColor: props.settings.answerBackgroundColor || initialValues.answerBackgroundColor,
                pawnId: props?.widgetProps?.pawnId || props?.pawnId,
                deploymentId: props.deploymentId,
                siteName: props.siteName,
            },
        })),
    getFilterFields: () => [],
})(AssessmentReportPlayer);
